module.exports = {
  name: 'M.Hassan Ahmed',
  shortName: 'Hassan',
  description:
    'AI engineer and full-stack builder. LLM agents, RAG systems, and production ML.',
  subtitle:
    'Inference Platform Engineer at Lyceum, working on dedicated inference for open models.',
  url: 'https://www.hassanahmed.net', // Domain of your site without prefix!
  prefix: '/',
  author: 'Hassan11196',
  // Contact email is stored only in encoded form so it never ends up as
  // plain text in the static HTML, the bundled JS, or the public source
  // map. The MailtoLink component decodes it inside an onClick handler,
  // which means harvesters that grep the page or the bundle won't find
  // the address — only a real user clicking the link does.
  emailEncoded: 'bS5oYXNzYW4xMTE5NkBvdXRsb29rLmNvbQ==',
  location: 'Zurich, Switzerland',
  availability: 'Open to AI / ML engineering conversations',
  twitter: '',
  fiverr: 'https://www.fiverr.com/hassanahmed19',
  interests:
    'I build LLM agents and RAG systems end-to-end, along with the HPC workflow management tooling that keeps the CMS experiment at CERN running. Recently: Archi (open-source RAG copilot for CMS ops), CloudCanvasAI, Gemini Alchemy, LLM DevMate, and the WMCore + Unified operations stack. Daily rotation: React, FastAPI, Kubernetes, ArgoCD, Puppet, OpenSearch. Previously: production CV/NLP systems at Retrocausal AI.',
  medium: 'https://medium.com/@hassan11196',
  freelancer: 'https://www.freelancer.com/u/hassan11196',
  facebook: 'https://www.facebook.com/hassan11196',
  github: 'https://www.github.com/hassan11196',
  cern_gitlab: 'https://gitlab.cern.ch/ahmedmu',
  hackerrank: 'https://www.hackerrank.com/hassan11196',
  linkedin: 'https://www.linkedin.com/in/hassan11196/',
  kaggle: 'https://www.kaggle.com/hassan11196',
  sourceer: 'https://sourcerer.io/hassan11196',
  resume:
    'https://drive.google.com/file/d/1ezHhPb1sDnfRhBoDz7gjoP6MbDBy7NRL/view?usp=sharing'
};
